export default __webpack_public_path__ + "static/media/strawberry6.39d83fc2.jpg";